import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

export default function InviteCodePanel() {
  const [codes, setCodes] = useState([]);
  const [generating, setGenerating] = useState(false);
  const [copied, setCopied] = useState(null);

  const fetchCodes = () => {
    api.get('/admin/invite-codes').then(setCodes).catch(() => {});
  };

  useEffect(() => { fetchCodes(); }, []);

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      await api.post('/admin/invite-codes');
      fetchCodes();
    } catch (err) {
      alert('Failed to generate code');
    } finally {
      setGenerating(false);
    }
  };

  const copyLink = (code) => {
    const url = `${window.location.origin}/register/${code}`;
    navigator.clipboard.writeText(url).then(() => {
      setCopied(code);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(code);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3 style={{ margin: 0 }}>Invite Passes</h3>
        <button className="btn-primary" onClick={handleGenerate} disabled={generating} style={{ padding: '6px 14px', fontSize: 13 }}>
          {generating ? 'Rolling...' : 'Roll a Pass'}
        </button>
      </div>
      <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <table className="data-table" style={{ fontSize: 13 }}>
          <thead>
            <tr>
              <th>Code</th>
              <th>Status</th>
              <th>Used By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {codes.length === 0 && (
              <tr><td colSpan={4} style={{ textAlign: 'center', opacity: 0.5 }}>No passes rolled yet</td></tr>
            )}
            {codes.map(c => {
              const isExpired = c.expires_at && new Date(c.expires_at) < new Date();
              const isAvailable = !c.used_by && !isExpired;
              return (
                <tr key={c.id}>
                  <td><code style={{ fontWeight: 600, letterSpacing: 1 }}>{c.code}</code></td>
                  <td>
                    {c.used_by ? (
                      <span className="badge badge-muted">Used</span>
                    ) : isExpired ? (
                      <span className="badge badge-redeemed">Expired</span>
                    ) : (
                      <span className="badge badge-success">Available</span>
                    )}
                  </td>
                  <td>{c.used_by_username || '-'}</td>
                  <td>
                    {isAvailable && (
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button
                          onClick={() => copyLink(c.code)}
                          className="btn-small"
                          title="Copy invite link"
                        >
                          {copied === c.code ? 'Copied!' : 'Copy Link'}
                        </button>
                        <button
                          onClick={() => copyCode(c.code)}
                          className="btn-small btn-secondary"
                          title="Copy code only"
                        >
                          Code
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
